import { AxiosRequest } from "_services/api";
import { useState } from "react";
import { IDefinirSenhaDetranForm } from "../@types";

export function useDefinirSenhaDetran() {
  const [loading, setLoading] = useState<boolean>(false);

  // tela pública (aberta via link): sem envio de token de autenticação
  const api = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW, true);

  async function validarToken(token: string) {
    try {
      setLoading(true);
      const { data } = await api.get(`/link-senha-detran/${token}`);
      return { hasErro: false, data };
    } catch (error: any) {
      return {
        hasErro: true,
        data: error?.response?.data ?? { message: "Link inválido ou expirado" },
      };
    } finally {
      setLoading(false);
    }
  }

  async function definirSenha(token: string, dados: IDefinirSenhaDetranForm) {
    try {
      setLoading(true);
      const { data } = await api.post(`/link-senha-detran/${token}`, dados);
      return { hasErro: false, data };
    } catch (error: any) {
      return {
        hasErro: true,
        data: error?.response?.data ?? { message: "Não foi possível salvar as credenciais" },
      };
    } finally {
      setLoading(false);
    }
  }

  return { validarToken, definirSenha, loading };
}
